<template>
  <div class="fullfillment-list-container">
    <p class="fullfillment-title">
      {{ $t("ffm_order_list") }}
    </p>
    <!-- [Fulfillment Center removed] Places filter -->
    <!-- <el-form label-position="top" class="fullfillment-center">
      <el-form-item :label="$t('ffm_center')">
        <el-select v-model="fullfillment_center" clearable @change="search">
          <el-option
            v-for="option in fullfillment_center_options"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          />
        </el-select>
      </el-form-item>
    </el-form> -->
    <!-- 筛选 + 搜索按钮-->
    <full-form
      ref="fullForm"
      class="filter-form fullfillment-form"
      :model.sync="config.form.model"
      :rules="config.form.rules"
      :rows="config.form.rows"
      :inline="true"
      label-position="top"
      @submit="search"
      @reset="reset"
      @onAction="productChange"
    />
    <div class="tab-container">
      <!-- tabs -->
      <el-tabs v-model="status" @tab-click="search">
        <el-tab-pane
          v-for="item in config.statuses"
          :key="item.value"
          :label="item.label"
          :name="item.value"
        >
          <span slot="label">
            {{
              `${item.label} ( ${
                tabsCount[item.key] === undefined ? "-" : tabsCount[item.key]
              } )`
            }}
          </span>
        </el-tab-pane>
      </el-tabs>
      <div class="mask-btn" v-if="cards.length">
        <show-original ref="showOriginal" :cb="() => fetchData()" />
      </div>
    </div>
    <template v-if="cards.length">
      <!-- 操作按钮组 -->
      <div class="bottom10">
        <!-- 批量导出 -->
        <el-dropdown trigger="click" @command="handleExport">
          <el-button>
            Export
            <i class="el-icon-arrow-down" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="excel" :disabled="!selectedIds.length">
              {{ $t("ffm_export_sheet") }}
            </el-dropdown-item>
            <el-dropdown-item command="all_excel">
              Export All Sheet
            </el-dropdown-item>
            <el-dropdown-item command="pdf" :disabled="!selectedIds.length">
              {{ $t("ffm_export_pdf") }}
            </el-dropdown-item>
            <el-dropdown-item
              command="regained"
              :disabled="!selectedIds.length"
            >
              Export Regained Picture
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- [Assign To removed] 批量转单 -->
        <!-- <el-button
          v-show="checkStatus('batchAssignTo', status) && areaPermission"
          :disabled="!selectedIds.length"
          @click="handleAssignTo(true)"
        >
          {{ $t("ffm_batch_assign_to") }}
        </el-button> -->
        <!-- 批量打印 -->
        <el-button
          v-show="checkStatus('batchPrint', status)"
          :disabled="!selectedIds.length"
          @click="handleBatchPrint"
        >
          {{ $t("ffm_batch_print") }}
        </el-button>
        <!-- 批量重新打印 -->
        <el-button
          v-show="checkStatus('batchReprint', status)"
          :disabled="!selectedIds.length"
          @click="handleBatchPrint"
        >
          {{ $t("ffm_batch_reprint") }}
        </el-button>
        <!-- 批量导入快递信息 -->
        <el-button
          v-show="checkStatus('importDelivery', status)"
          :disabled="!selectedIds.length"
          @click="showImportDialog"
        >
          {{ $t("ffm_import_delivery_information") }}
        </el-button>
        <!-- 排序 -->
        <Sort @sort="handleSort" />
      </div>
      <!-- 全选 / 全展开 -->
      <div class="bottom10">
        <el-row>
          <el-col :span="12">
            <el-checkbox v-model="allChecked" @change="selectAll">
              {{ $t("ffm_select_all") }}
            </el-checkbox>
            <el-tag v-if="selectedIds.length" style="margin-left:15px;">
              {{
                `${Number(selectedIds.length).toLocaleString("en-US")} ${$t(
                  "ffm_bookings_are_selected"
                )}`
              }}
            </el-tag>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-button type="text" size="small" @click="expandAll()">
              {{ allExpanded ? $t("ffm_collapse_all") : $t("ffm_expand_all") }}
              <i
                class="el-icon-caret-bottom el-icon--right expend-all"
                :class="{ 'transform-icon': allExpanded }"
              />
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- card -->
      <el-card
        v-for="(card, index) in cards"
        :key="index"
        class="box-card bottom10"
        :class="{ checked: card.checked }"
      >
        <div slot="header" class="clearfix">
          <el-row>
            <el-col :span="8">
              <el-checkbox v-model="card.checked" />
              {{
                $t("ffm_order_no") +
                  ":" +
                  (card.order_base_info.order_no || "-")
              }}
            </el-col>
            <el-col :span="8">
              <span>
                {{
                  $t("ffm_booking_time") +
                    ":" +
                    (card.order_base_info.booking_time || "-")
                }}
              </span>
            </el-col>
            <el-col :span="8" style="text-align:right;">
              <el-tag v-if="card.hasReverse" type="danger">
                {{ $t("ffm_abnormal_order") }}
              </el-tag>
              <!-- 铁路票, 而且不包含 逆向流时显示-->
              <el-button
                v-if="!isManualOrderTab"
                v-show="
                  checkStatus('requestReupload', card.order_base_info.status) &&
                    card.order_base_info.template_id === 1 &&
                    !card.hasReverse
                "
                type="text"
                size="small"
                @click="requestReupload(card)"
              >
                {{ $t("ffm_request_reupload") }}
              </el-button>
              <el-tag type style="margin:0 10px;background:#a0b2cc">
                {{
                  card.order_base_info.template_id === 1
                    ? "Rail Ticket"
                    : "Physical Product"
                }}
              </el-tag>
              <el-button
                v-show="!card.expand"
                type="text"
                size="small"
                @click="expandUnit(card)"
              >
                {{ $t("ffm_expand_unit") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-button
                v-show="card.expand"
                type="text"
                size="small"
                @click="expandUnit(card)"
              >
                {{ $t("ffm_collapse_unit") }}
                <i class="el-icon-caret-top el-icon--right" />
              </el-button>
            </el-col>
          </el-row>
        </div>
        <!-- 操作按钮 -->
        <el-row>
          <el-col :span="12">
            <h4>{{ card.order_base_info.activity_name || "-" }}</h4>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <div v-if="!isManualOrderTab">
              <!-- Regain -->
              <el-button
                v-if="
                  card.order_base_info.status ===
                    bookingStatusConst[CONST_waiting_for_regain] &&
                    card.isBookingRegain
                "
                @click="handleRegain('booking', card, 'edit')"
              >
                Regain
              </el-button>
              <el-button
                v-if="
                  card.order_base_info.status !==
                    bookingStatusConst[CONST_waiting_for_regain] &&
                    hasRegainFilePath('booking', card)
                "
                @click="handleRegain('booking', card, 'view')"
              >
                Regain Detail
              </el-button>
              <!-- history 均显示-->
              <el-button @click="showHistoryListDialog(card)">
                {{ $t("ffm_revision_history") }}
              </el-button>
              <!-- 当指定status下, 非全是逆向流, 是铁路票 -->
              <el-dropdown
                v-show="
                  checkStatus('print', card.order_base_info.status) &&
                    card.order_base_info.template_id === 1 &&
                    !card.allIsReverse
                "
                trigger="click"
                @command="command => handlePrintOrder(command, card)"
              >
                <el-button>
                  {{ $t("ffm_Print") }}
                  <i class="el-icon-arrow-down" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item command="cloud">
                    {{ $t("ffm_cloud_print") }}
                  </el-dropdown-item>-->
                  <el-dropdown-item command="local">
                    {{ $t("ffm_local_print") }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- 当指定status下, 非全是逆向流, 是铁路票 -->
              <el-dropdown
                v-show="
                  checkStatus('reprint', card.order_base_info.status) &&
                    card.order_base_info.template_id === 1 &&
                    !card.allIsReverse
                "
                trigger="click"
                @command="command => handlePrintOrder(command, card, true)"
              >
                <el-button>
                  {{ $t("ffm_Reprint") }}
                  <i class="el-icon-arrow-down" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item command="cloud">
                    {{ $t("ffm_cloud_print") }}
                  </el-dropdown-item>-->
                  <el-dropdown-item command="local">
                    {{ $t("ffm_local_print") }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- 邮寄 -->
              <el-button
                v-show="
                  checkStatus('mail', card.order_base_info.status) &&
                    !card.allIsReverse
                "
                @click="showMailDialog(card)"
              >
                {{ $t("ffm_mail") }}
              </el-button>
              <!-- 重填邮寄 -->
              <el-button
                v-show="
                  checkStatus('remail', card.order_base_info.status) &&
                    !card.allIsReverse
                "
                @click="showMailDialog(card, true)"
              >
                {{ $t("ffm_mailed") }}
              </el-button>
              <!-- [Assign To removed] 单个转单 -->
              <!-- <el-button
                v-show="checkAssignTo(card) && areaPermission"
                @click="handleAssignTo(false, card)"
              >
                {{ $t("ffm_assign_to") }}
              </el-button> -->
            </div>
          </el-col>
        </el-row>
        <!--  邮寄的order -->
        <el-row
          v-if="card.order_base_info.ticket_type === 1"
          class="card-content"
        >
          <el-col
            v-for="item in config.card.items_mail"
            :key="item.key"
            :span="12"
          >
            <el-row>
              <el-col :span="6" class="info">
                {{ item.label }}
              </el-col>
              <el-col v-if="item.format" :span="18" class="info_value">
                {{ item.format(card.order_base_info[item.key]) || "-" }}
              </el-col>
              <el-col
                v-else-if="item.key === 'unit'"
                :span="18"
                class="info_value"
              >
                {{ item.formatter(item, card) }}
              </el-col>
              <el-col v-else :span="18" class="info_value">
                {{ card.order_base_info[item.key] || "-" }}
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!--  自取的order -->
        <el-row v-else class="card-content">
          <el-col
            v-for="item in config.card.items_pickup"
            :key="item.key"
            :span="12"
          >
            <el-row>
              <el-col :span="6" class="info">
                {{ item.label }}
              </el-col>
              <el-col v-if="item.format" :span="18" class="info_value">
                {{ item.format(card.order_base_info[item.key]) || "-" }}
              </el-col>
              <el-col
                v-else-if="item.key === 'unit'"
                :span="18"
                class="info_value"
              >
                {{ item.formatter(item, card) }}
              </el-col>
              <el-col v-else :span="18" class="info_value">
                {{ card.order_base_info[item.key] || "-" }}
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div v-show="card.expand">
          <!-- card => unit => expend -->
          <list-table
            :data="card.order_unit_file"
            :columns="config.table.columns"
          />
        </div>
      </el-card>
    </template>
    <p v-else class="no-data-tips">
      {{ $t("ffm_no_data") }}
    </p>
    <!-- 分页 -->
    <div style="margin-top: 12px; text-align: right;margin-right: 36px;">
      <el-pagination
        :current-page="pagination.currentPage"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        @size-change="sizeChange"
        @current-change="currentChange"
      />
    </div>
    <!-- unit => table => dialog => table-->
    <history-list ref="historyList" />
    <!-- 导出弹窗 -->
    <el-dialog
      class="export-dialog"
      :visible.sync="exportDialogVisible"
      title="Export"
      @close="handleExportDialogClose"
    >
      <el-checkbox-group v-model="exportTypeList">
        <div v-for="option in config.exportOptions" :key="option.value">
          <el-checkbox :label="option.value">
            {{ option.label }}
          </el-checkbox>
        </div>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="exportExcel">Export</el-button>
      </span>
    </el-dialog>
    <!-- 邮寄弹窗 -->
    <el-dialog
      class="mail-dialog"
      :visible.sync="mailDialogVisible"
      :title="$t('ffm_mail')"
    >
      <full-form
        ref="mailForm"
        label-width="200px"
        :model="config.mail_form.model"
        :rules="config.mail_form.rules"
        :rows="config.mail_form.rows"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="mailDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="checkMailStatus">{{
          $t("ffm_mail")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 打印列表分类弹窗 -->
    <el-dialog
      :visible.sync="printCountDialogVisible"
      :title="$t('ffm_confirm_print')"
    >
      <p class="print-tips">
        {{ "1." + $t("ffm_not_contain_abnormal_order") }}
      </p>
      <p class="print-tips">
        {{ "2." + $t("ffm_pls_confirm_ready_printer") }}
      </p>
      <list-table :columns="config.printTableCloumns" :data="printTableData" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="printCountDialogVisible = false">Cancel</el-button>
      </span>
    </el-dialog>
    <!-- 打印过程 -->
    <el-dialog
      :visible.sync="printingDialogVisible"
      :show-close="false"
      class="printing-dialog"
      @close="processClose"
    >
      <div slot="title" style="font-size:16px;">
        {{ $t("ffm_printing_list") }}
        <el-button style="float:right" size="mini" @click="processClose">
          {{ $t("ffm_collapse") }}
        </el-button>
      </div>
      <!-- items - order -->
      <p v-if="printingItems.orders.length">
        Orders
      </p>
      <transition-group name="list" tag="p">
        <div
          v-for="(item, index) in printingItems.orders"
          :key="index"
          class="printing-item"
        >
          {{ item.ticket_id }}
          <span
            v-show="item.status === 0"
            class="print-status print-status-error"
            style="color:#ff7273"
          >
            <i class="error-message">
              {{ $t("ffm_canceled") }}
              <i class="el-icon-close" />
            </i>
            <i
              class="print-status-reprint"
              @click="handlePrintOrder('cloud', item, true)"
              >{{ $t("ffm_reprint") }}</i
            >
          </span>
          <span
            v-show="item.status === 2"
            class="print-status print-status-printing"
          >
            <i class="printing-message">
              {{ $t("ffm_printing") }}
              <i class="el-icon-loading" />
            </i>
            <i class="print-status-cancel" @click="cancelPrint(item)">Cancel</i>
          </span>
          <span
            v-show="item.status === 1"
            class="print-status print-status-success"
          >
            {{ $t("ffm_print_success") }}
            <i class="el-icon-check" />
          </span>
          <span
            v-show="item.status === 3"
            class="print-status print-status-error"
            style="color:#ff7273"
          >
            <i class="error-message">
              {{ $t("ffm_print_fail") }}
              <i class="el-icon-close" />
            </i>
            <i
              class="print-status-reprint"
              @click="handlePrintOrder('cloud', item, true)"
              >{{ $t("ffm_reprint") }}</i
            >
          </span>
        </div>
      </transition-group>
      <!-- items - unit -->
      <p v-if="printingItems.units.length">
        Units
      </p>
      <transition-group name="list" tag="p">
        <div
          v-for="(item, index) in printingItems.units"
          :key="index"
          class="printing-item"
        >
          {{ item.unit_file_id }}
          <span
            v-show="item.status === 0"
            class="print-status print-status-error"
            style="color:#ff7273"
          >
            <i class="error-message">
              {{ $t("ffm_canceled") }}
              <i class="el-icon-close" />
            </i>
            <i
              class="print-status-reprint"
              @click="handlePrintUnit('cloud', item, false, true)"
              >{{ $t("ffm_reprint") }}</i
            >
          </span>
          <span
            v-show="item.status === 2"
            class="print-status print-status-printing"
          >
            <i class="printing-message">
              {{ $t("ffm_printing") }}
              <i class="el-icon-loading" />
            </i>
            <i class="print-status-cancel" @click="cancelPrint(item, 'unit')"
              >Cancel</i
            >
          </span>
          <span
            v-show="item.status === 1"
            class="print-status print-status-success"
          >
            {{ $t("ffm_print_success") }}
            <i class="el-icon-check" />
          </span>
          <span
            v-show="item.status === 3"
            class="print-status print-status-error"
            style="color:#ff7273"
          >
            <i class="error-message">
              {{ $t("ffm_print_fail") }}
              <i class="el-icon-close" />
            </i>
            <i
              class="print-status-reprint"
              @click="handlePrintUnit('cloud', item, false, true)"
              >{{ $t("ffm_reprint") }}</i
            >
          </span>
        </div>
      </transition-group>
    </el-dialog>
    <!-- 导入弹窗 -->
    <el-dialog
      class="import-dialog"
      :visible.sync="importVisible"
      :title="$t('ffm_import_delivery_information')"
      @close="
        () => {
          fileList = [];
          logisticsList = [];
        }
      "
    >
      <p>
        {{ $t("ffm_pls_import_delivery") + "-" }}
        <el-button type="text" @click="downloadTemplate">
          {{ $t("ffm_download_template") }}
        </el-button>
      </p>

      <p />
      <div class="upload-container">
        <ul class="el-upload-list el-upload-list--text" style="width:360px;">
          <li
            v-for="(file, index) in fileList"
            :key="index"
            :class="[
              'el-upload-list__item',
              'is-' + (file.status || 'success')
            ]"
          >
            <a class="el-upload-list__item-id">
              <i class="el-icon-document" />
              {{ file.name }}
            </a>
            <label class="el-upload-list__item-status-label">
              <i class="el-icon-upload-success el-icon-circle-check" />
            </label>
            <i class="el-icon-close" @click="handleRemove(index)" />
            <el-progress
              v-if="file.status === 'uploading'"
              type="line"
              :stroke-width="2"
              :percentage="parseInt(file.percentage, 10)"
            />
          </li>
        </ul>
        <input
          ref="content_file_input"
          type="file"
          style="display: none;"
          accept=".xls, .xlsx"
          @change="uploadContent"
        />
        <el-button
          v-show="fileList.length !== 1"
          type="primary"
          @click="$refs['content_file_input'].click()"
        >
          {{ $t("ffm_upload_file") }}
        </el-button>
      </div>
      <p />
      <p v-show="fileList.length !== 1" style="color:#aaa">
        {{ $t("ffm_support_file") }}
      </p>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            importVisible = false;
            fileList = [];
          "
          >Cancel</el-button
        >
        <el-button type="primary" @click="batchMail">Confirm</el-button>
      </span>
    </el-dialog>

    <regain-edit-dialog
      :visible.sync="regainEditDialogVisible"
      :data="selectedRow"
      :level="selectedLevel"
    />
    <regain-view-dialog
      :visible.sync="regainViewDialogVisible"
      :data="selectedRow"
      :level="selectedLevel"
      @edit="regainEditDialogVisible = true"
    />
  </div>
</template>

<script>
import { pageKey } from "./const";
import initConfig from "./config.js";
import moment from "moment";
import {
  getOrderList,
  // [Fulfillment Center removed] getAreaListForAccount,
  getCategory,
  getPhysicalCouriers
} from "@/services/fulfillment-api";
import FullForm from "../components/form/model.vue";
import ListTable from "../components/table/listTable.vue";
import HistoryList from "./historyList/model";
import Sort from "./sort/sort";
import RegainEditDialog from "./components/regainEditDialog.vue";
import RegainViewDialog from "./components/regainViewDialog.vue";

// mixins
import cardMixin from "../mixins/card";
import exportMixin from "../mixins/export";
import paginationMixin from "../mixins/pagination";
import assignMixin from "../mixins/assign";
import mailMixin from "../mixins/mail";
import printMixin from "../mixins/print";
import regainMixin from "../mixins/regain";
import ShowOriginal from "../components/ShowOriginal/index.vue";

import { bookingStatusConst, CONST_waiting_for_regain } from "./utils/const";

const ADMIN_REGION_ID = 999;

export default {
  components: {
    FullForm,
    ListTable,
    HistoryList,
    Sort,
    RegainEditDialog,
    RegainViewDialog,
    ShowOriginal
  },
  mixins: [
    cardMixin,
    exportMixin,
    paginationMixin,
    assignMixin,
    mailMixin,
    printMixin,
    regainMixin
  ],
  data() {
    return {
      regainEditDialogVisible: false,
      regainViewDialogVisible: false,
      areaPermission: false,
      config: { form: { rows: [] } },
      sort_type: 3,
      fullfillment_center: "",
      status: "-1",
      tabsCount: {},
      region_id: "", // assignTo
      my_fullfillment_center_options: [],
      searchParamsSnap: {},
      courierData: [],
      selectedRow: {},
      selectedLevel: ""
    };
  },
  computed: {
    bookingStatusConst() {
      return bookingStatusConst;
    },
    CONST_waiting_for_regain() {
      return CONST_waiting_for_regain;
    },
    fullfillment_center_options() {
      if (this.areaPermission) {
        // 如果有 ADMIN 权限，返回所有 region 列表
        return this.config.fullfillment_center_options;
      } else {
        // 否则只返回当前账户下的 region 列表
        return this.my_fullfillment_center_options;
      }
    },
    // 判断当前是否是 Manual Order 标签页
    isManualOrderTab() {
      return this.status === "0";
    },
    courierOpts() {
      return this.courierData.map(item => ({
        label: item.courier_name,
        value: item.courier_name
      }));
    }
  },
  async created() {
    this.init();
  },
  methods: {
    // 检查显示状态
    checkStatus(key, status) {
      return this.config.buttonRefer[key].includes(Number(status));
    },
    // search
    search() {
      this.fetchData(false);
    },
    reset() {
      this.$refs.fullForm.modelData = { ...this.defaultModel };
      this.search();
    },
    async fetchData(init) {
      const status = this.$refs.showOriginal && this.$refs.showOriginal.status;
      let model = init ? this.config.form.model : this.$refs.fullForm.modelData;
      let params = {
        no_mask: status === 1,
        // [Fulfillment Center removed] region_id: this.fullfillment_center,
        page: this.pagination.currentPage, // in query, 页码,
        limit: this.pagination.pageSize, // in query, 页长,
        status: Number(this.status), // in query, 状态,
        travel_time_start: "", // in query, 出行时间,
        travel_time_end: "", // in query, 出行时间,
        booking_time_start: "", // in query, 预定时间,
        booking_time_end: "", // in query, 预定时间,
        mailing_time_start: "",
        mailing_time_end: "",
        // [Fulfillment Method removed] ticket_type: model.ticket_type,
        order_no: model.order_no, // in query, order_no / booking no / voucher ID,
        template_id: model.template_id, // in query, template_id,
        physical_type: (model.physical_type || []).join(), // in query, physical_type,
        sort_type: this.sort_type,
        [model.search_type]: model.keywords
      };
      if (model.time && model.time.length && model.time[0] !== null) {
        let start = moment(model.time[0]).format("YYYY-MM-DD");
        let end = moment(model.time[1]).format("YYYY-MM-DD");
        let type = model.time_type;
        params[`${type}_time_start`] = start;
        params[`${type}_time_end`] = end;
      }

      this.searchParamsSnap = JSON.parse(JSON.stringify(params));

      let resp = await getOrderList(params);
      this.cards = this.handleRes(resp.result.order_list);
      this.pagination.total = resp.result.count;
      this.tabsCount = resp.result.status_statistical || {};
      this.allChecked = false;
      // 权限由后端控制
      let _region_list = resp.result.region_list || [];
      this.areaPermission = this.getPermission(
        _region_list.find(region => {
          return region.region_id === 999;
        }) || {}
      );
      // 格式化
      this.my_fullfillment_center_options = _region_list.map(region => {
        return {
          value: region.region_id,
          label: region.region_name
        };
      });
      init && (this.fullfillment_center = resp.result.check_region.region_id);
    },
    // 处理 数据
    handleRes(data) {
      return data.map(v => {
        v.expand = this.allExpanded;
        // 清除选中
        v.checked = false;
        // 包含逆向流
        v.hasReverse = this.containReverse(v);
        // 均为逆向流
        v.allIsReverse = this.allIsReverse(v);

        // 是否为 booking 层级的 regain
        let isBookingRegain = this.checkBookingRegainBtn(v);
        v.isBookingRegain = isBookingRegain;
        for (const unit of v.order_unit_file) {
          unit.isBookingRegain = isBookingRegain;
        }

        return v;
      });
    },
    // 排序
    handleSort(op) {
      this.pagination.currentPage = 1;
      if (op.curField === "bookingTime") {
        this.sort_type = op.curOrder === "asc" ? 1 : 3;
      } else {
        this.sort_type = op.curOrder === "asc" ? 2 : 4;
      }
      this.search();
    },
    // 初始化配置
    initConfig() {
      this.config = initConfig.call(this);
      this.defaultModel = { ...this.config.form.model };
    },
    // 跳转参数
    initJumpParams() {
      let params = this.$route.params;
      if (Object.keys(params).length) {
        // [Fulfillment Center removed] this.fullfillment_center = params.region_id;
        this.config.form.model.time = params.time;
        this.config.form.model.time_type = params.time_type;
        this.config.form.model.fulfillment_goods = [params.tickets_goods_value];
        this.config.form.model.template_id = params.tickets_goods_value;
        this.status = params.status;
      }
    },
    // [Fulfillment Center + Assign To removed] initAreaList
    // async initAreaList() {
    //   let res = await getAreaListForAccount();
    //   let ops = res.result.map(v => {
    //     return {
    //       value: v.id,
    //       label: v.region_name
    //     };
    //   });
    //   if (ops && ops.length) {
    //     this.config.fullfillment_center_options = ops;
    //     this.config.assign_ops = ops.filter(
    //       v => v.label.toLowerCase() !== "all"
    //     );
    //   }
    // },
    // 初始化 product Options
    async initCategory() {
      let res = await getCategory();
      let row = this.config.form.rows.find(v => v.key === "templates");
      row.options = res.result.map(v => {
        return {
          label: v.template_name,
          value: v.template_id,
          children: v.physical_type_list.map(el => {
            return {
              value: el.physical_type,
              label: el.physical_type_name
            };
          })
        };
      });
    },
    // 查看是否有权限
    getPermission(region) {
      return Number(region.region_id) === ADMIN_REGION_ID;
    },

    initPageSize() {
      let size = window.localStorage.getItem(pageKey);
      this.pagination.pageSize = Number(size) || this.pagination.pageSize;
    },

    async init() {
      // 初始化配置
      this.initConfig();
      // 获取分类
      await Promise.all([this.initCategory(), this.getCouriers()]);
      // 跳转参数
      this.initJumpParams();
      // 查询打印状态 - 不再需要云打印
      // this.checkPrintingCode();
      // [Fulfillment Center + Assign To removed] this.initAreaList();
      // init page size
      this.initPageSize();
      // 搜索
      this.fetchData(true);
    },

    productChange(event) {
      if (event.prop !== "template_id") {
        return;
      }

      let form = this.config.form;
      let rows = form.rows;
      form.model.physical_type = [];

      let suppliers = rows.find(v => v.key === "suppliers");
      suppliers.options = [];

      let templates = rows.find(v => v.key === "templates");
      templates.options.forEach(e => {
        if (e.value == event.value) {
          suppliers.options = e.children;
        }
      });
    },
    // 获取物流公司
    async getCouriers() {
      let res = (await getPhysicalCouriers()).result || {};
      this.courierData = res.items || [];
      let target = this.config.mail_form.rows.find(
        row => row.prop === "tracking_website"
      );
      target && (target.options = this.courierOpts);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/order-list.scss";
</style>
<style lang="scss">
@import "../styles/common.scss";
</style>
<style>
@import "../styles/order-list-el.scss";
</style>
